export const deleteCookieToken = () => {
  window.localStorage.removeItem('user_token')
  document.cookie =
    'user_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
}
